import { render, staticRenderFns } from "./WorkforceListFiltersBasic.vue?vue&type=template&id=eba61dfe&"
import script from "./WorkforceListFiltersBasic.vue?vue&type=script&lang=js&"
export * from "./WorkforceListFiltersBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports